export default __webpack_public_path__ + "static/media/packageActive.d3ba2d77.svg";